<div [formGroup]="form" class="form-group">
    <mat-label id="checkbox-group-{{config.id}}"> {{config.attrs.label}}</mat-label>
    <mat-checkbox *ngFor="let choice of config.attrs.choices| keyvalue;" [value]="choice.key" [formControlName]="config.id + '['+choice.key+']'" checkboxInput [attrs]="config.attrs" >
        {{choice.value}}
    </mat-checkbox>
</div>
